module.exports = __webpack_public_path__ + "3bd0fed9aa3305cc9771222e715cf304.MP3";